var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6029 7.02429H10.8557V1.27714C10.8557 0.571921 10.2838 0 9.57857 0H8.30143C7.59621 0 7.02429 0.571921 7.02429 1.27714V7.02429H1.27714C0.571921 7.02429 0 7.59621 0 8.30143V9.57857C0 10.2838 0.571921 10.8557 1.27714 10.8557H7.02429V16.6029C7.02429 17.3081 7.59621 17.88 8.30143 17.88H9.57857C10.2838 17.88 10.8557 17.3081 10.8557 16.6029V10.8557H16.6029C17.3081 10.8557 17.88 10.2838 17.88 9.57857V8.30143C17.88 7.59621 17.3081 7.02429 16.6029 7.02429Z",
    fill: "url(#paint0_linear_771_8302)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_771_8302",
    x1: 8.94,
    y1: -1.52244e-9,
    x2: 8.99109,
    y2: 23.7038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C71D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04848"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.e17d3aa61dcf719bbfe062f0cc011cbd.svg";
export { ForwardRef as ReactComponent };